import {i18n} from '@online-offer/i18n';
import {Show, Space, ThemeIconKey} from 'platform/foundation';

import {ReactElement} from 'react';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {SectionId, Sections} from '../../consts/Sections';
import {CardContainer} from '../CardContainer/CardContainer';
import {FlagProps} from '../Flag/Flag';
import {Separator} from '../Separator/Separator';

export interface SectionProps extends TestIdProps {
  id: SectionId;
  icon?: ThemeIconKey;
  children: ReactElement | ReactElement[];
  isWithBreakLine?: boolean;
  cardContainerFlagProps?: FlagProps | Nullish;
  isWithGradient?: boolean | Nullish;
  isOverflowHidden?: boolean | Nullish;
}

export function Section(props: SectionProps) {
  const section = Sections.find((section) => section.id === props.id);
  const isWithBreakLine = props.isWithBreakLine ?? false;
  return (
    <>
      <section id={props.id} data-testid={suffixTestId('section', props)}>
        <CardContainer
          heading={section?.menuTitleTranslationKey ? i18n.t(section.menuTitleTranslationKey) : ''}
          flag={props.cardContainerFlagProps}
          isWithGradient={props.isWithGradient}
          isOverflowHidden={props.isOverflowHidden}
        >
          {props.children}
        </CardContainer>
      </section>
      <Space vertical={8} />
      <Show when={isWithBreakLine}>
        <Separator />
        <Space vertical={8} />
      </Show>
    </>
  );
}
